module.exports = __webpack_public_path__ + "static/media/bread-slice.f1a65114.svg";